import request from '@/utils/request'

export function login(data) {
	return request.post('user/login', data, {
		auth: true
	})
}

export function schoolLogin(data) {
	return request.post('user/admin/login', data, {
		auth: true
	})
}

export function register(data) {
	return request.post('user/register', data, {
		auth: true
	})
}


export function schoolRegister(data) {
	return request.post('user/admin/register', data, {
		auth: true
	})
}

export function sendCode(params) {
	return request.get('user/getCode', {
		params,
		auth: true
	})
}

export function forgetPass(data) {
	return request.post('user/forgetPwd', data, {
		auth: true
	})
}
export function editorUserInfo(data) {
	return request.post('user/updateInfo', data)
}
// 绑定高校
export function bindUserSchool(data) {
	return request.post('user/bind', data)
}

// 查询项目
export function queryProject(params) {
	return request.get('user/project', {
		params
	})
}